import React from 'react'
import { withRouter } from 'react-router-dom'
import Page from '../components/Page'

import '../stylesheets/pages/Thanks.scss'

class Thanks extends React.Component {
    componentDidMount = () => {
        localStorage.removeItem(this.props.match.params.slug)
    }
    render() {
        return (
            <Page title={this.props.validation.thanks_title}>
                <div className="Thanks">
                    <p dangerouslySetInnerHTML={{ __html: this.props.validation.thanks_text }} />
                </div>
            </Page>
        )
    }
}

export default withRouter(Thanks)
